module.exports = __webpack_public_path__ + "img/maradona-rebello.0b21fa6c.webp";